// 公共请求路径前缀
export const BASE_API = "pc";

// 需要 token 验证的接口列表
export const TOKEN_API = [];

// 非必须 token 的接口（可带可不带）
export const LOGIN_API = [];

// 上传相关接口
export const UPLOAD_API = ["/pc/issued/upload"];



// WEBPACK FOOTER //
// ./src/utils/constant.js